import type { ColumnsType } from 'antd/es/table';
import {formatMoney, formatDate} from 'common/helpers'
import { Tag } from 'common/components';
// import { TransactionDataType } from "../types"

// export const COLUMNS: ColumnsType<TransactionDataType> = [
export const COLUMNS: ColumnsType<any> = [
  {
    title: 'Date',
    dataIndex: 'date',
    render: (text: string) => formatDate(text),
  },
  {
    title: 'Account name',
    dataIndex: 'account',
  },
  {
    title: 'Reference',
    dataIndex: 'reference',
  },
  {
    title: 'Notes',
    dataIndex: 'notes',
  },
  {
    title: 'Spent',
    dataIndex: 'spent',
    align: 'right',
    render: (text: string) => !text ? '' : formatMoney( parseInt(text) , { cents: true, }),
  },
  {
    title: 'Received',
    dataIndex: 'received',
    align: 'right',
    render: ( text: string) => !text ? '' : formatMoney( parseInt(text) , { cents: true, }),
  },
  {
    title: 'Status',
    dataIndex: 'status',
    render: (text: string) => <Tag color={(text === 'Unreconciled') ? "warning":"default"}>{text}</Tag>,
  },
];

export const ROWS: any[] = [
  { key: '01', date: '2003-04-12', account: 'John Brown',     spent: 32, received: 333, status: 'Unreconciled',  reference: 'Legal Fee', },
  { key: '02', date: '2003-04-22', account: 'Jim Green',      spent: 42, received: 333, status: 'Unreconciled',  reference: 'Broker Fee', },
  { key: '03', date: '2003-04-28', account: 'Joe Black',      spent: 32, received: 333, status: 'Unreconciled',  reference: 'Drawdown', },
  { key: '04', date: '2003-05-02', account: 'Disabled User',  spent: 99, received: 333, status: 'Unreconciled',  reference: 'Drawdown', },
  { key: '05', date: '2003-05-13', account: 'John Brown',     spent: 32, received: 333, status: 'Unreconciled',  reference: 'Legal Fee', },
  { key: '06', date: '2003-05-20', account: 'Jim Green',      spent: 42, received: 333, status: 'Unreconciled',  reference: 'Broker Fee', },
  { key: '07', date: '2003-05-22', account: 'Joe Black',      spent: 32, received: 333, status: 'Unreconciled',  reference: 'Drawdown', },
  { key: '08', date: '2003-05-27', account: 'Disabled User',  spent: 99, received: 333, status: 'Unreconciled',  reference: 'Drawdown', },
  { key: '09', date: '2003-05-30', account: 'John Brown',     spent: 32, received: 333, status: 'Reconciled',    reference: 'Legal Fee', },
  { key: '10', date: '2003-06-02', account: 'Jim Green',      spent: 42, received: 333, status: 'Reconciled',    reference: 'Broker Fee', },
  { key: '11', date: '2003-06-09', account: 'Joe Black',      spent: 32, received: 333, status: 'Reconciled',    reference: 'Drawdown', },
  { key: '12', date: '2003-06-12', account: 'Disabled User',  spent: 99, received: 333, status: 'Reconciled',    reference: 'Drawdown', },
  { key: '13', date: '2003-06-14', account: 'John Brown',     spent: 32, received: 333, status: 'Reconciled',    reference: 'Legal Fee', },
  { key: '14', date: '2003-06-21', account: 'Jim Green',      spent: 42, received: 333, status: 'Reconciled',    reference: 'Broker Fee', },
  { key: '15', date: '2003-06-25', account: 'Joe Black',      spent: 32, received: 333, status: 'Reconciled',    reference: 'Drawdown', },
  { key: '16', date: '2003-06-27', account: 'Disabled User',  spent: 99, received: 333, status: 'Reconciled',    reference: 'Drawdown', },
];
